import { Vote } from '~/definitions/vote';
import { getStore } from '~/mobx/AppStore';
import getMembershipBySlagId from '~/utils/getMembershipBySlagId';

const setInitialVoteData = () => {
    const { candidateStore, voteStore, ballotStore } = getStore();
    const { selectedElectionId, selectedRegionId, selectedSlagId, getIsStandAdmin, getStandAdminId } = ballotStore;
    const standAdminId = getStandAdminId();
    const voteFrom = getIsStandAdmin() ? 'stand' : 'web';
    const membershipId = getMembershipBySlagId(ballotStore.customers?.membership, selectedSlagId)?.id || '';
    const companyId = ballotStore.company?.companyId || '';

    const initialVotes: Vote[] = candidateStore.candidates.map((candidate) => {
        return {
            kumuler: candidate.cumulation ? 1 : 0,
            candidate_id: candidate.id,
            election_id: selectedElectionId,
            region_id: selectedRegionId,
            s_lag_id: companyId,
            stand_admin_id: standAdminId || '',
            ts: '',
            user_id: membershipId,
            vote_from: voteFrom,
            votes: 1,
        };
    });
    voteStore.setVotes(initialVotes);
};

export default setInitialVoteData;
